module.exports = __webpack_public_path__ + "img/symbol_3.6a2124cb.png";